import { applyStyleToElement } from './applyStyleToElement';
import { RESET_TRANSITION_STYLE } from './constants';
import { TransitionStopReason } from './types';

export const cleanUpAnimation = (element: HTMLElement, completionType: TransitionStopReason) => {
  if (completionType === TransitionStopReason.end)
    applyStyleToElement(RESET_TRANSITION_STYLE, element);
};
